module.exports = __webpack_public_path__ + "static/media/planet2.7b3a9fa2.png";